import { Navigate, useLocation } from "react-router-dom";
import { PATHS } from "@/lib/router";
import { useAuthStore } from "@/features/auth/hooks";
import { observer } from "mobx-react-lite";
import { checkGroupFromRole } from "@/helpers";

const PERMISSION_ROUTE_PRIORITY = [
  ["company_information:view", PATHS.DASHBOARD],
  ["organization:view", PATHS.ORGANIZATION],
  ["esg_dashboard:view", PATHS.ANALYTICS_DASHBOARD],
  ["master_data:view", PATHS.ESG_MASTER_DATA],
  ["reporting_boundary:view", PATHS.ESG_REPORTING_BOUNDARY],
  ["target_setting:view", PATHS.TARGET_SETUP],
  ["esg_data_entry:view", PATHS.DATA_ENTRY],
  ["esg_reporting:view", PATHS.ESG_REPORT_PREVIEW_LIST],
  ["settings:view", PATHS.SETTINGS],
  ["user_list:view", PATHS.USER_LIST],
];

export const getFirstAllowedRoute = (permissions = []) => {
  if (!Array.isArray(permissions) || permissions.length === 0) {
    return PATHS.NOT_FOUND;
  }

  const permissionSet = new Set(permissions);

  for (const [perm, route] of PERMISSION_ROUTE_PRIORITY) {
    if (permissionSet.has(perm)) {
      return route;
    }
  }

  return PATHS.NOT_FOUND;
};

// Public route wrapper - redirects to dashboard if already authenticated
export const PublicRoute = observer(({ children }) => {
  const { isAuthenticated, user } = useAuthStore();
  const location = useLocation();

  // Allow verify 2FA page
  if (location.pathname === PATHS.VERIFY_2FA_CODE) {
    return children;
  }

  const validGroup = checkGroupFromRole(user?.role);

  if (isAuthenticated) {
    if (user?.isNew) return <Navigate to={PATHS.CHANGE_PASSWORD} replace />;

    if (validGroup === "admin_group")
      return <Navigate to={PATHS.USER_LIST} replace />;
    if (validGroup === "bank_group")
      return <Navigate to={PATHS.CARBON_DASHBOARD} replace />;

    const redirectRoute = getFirstAllowedRoute(user?.permissions);
    return <Navigate to={redirectRoute} replace />;
  }

  //Original code
  // if (isAuthenticated) {
  //   // Force password change for new users before anything else
  //   if (user?.isNew) {
  //     return <Navigate to={PATHS.CHANGE_PASSWORD} replace />;
  //   }

  //   // Redirect to dashboard if already authenticated
  //   return (
  //     <Navigate
  //       to={
  //         user?.delegationOnlyAccess
  //           ? PATHS.ESG_DELEGATED_ENTRY
  //           : validGroup === "admin_group"
  //             ? PATHS.USER_LIST
  //             : validGroup === "bank_group"
  //               ? PATHS.CARBON_DASHBOARD
  //               : PATHS.DASHBOARD
  //       }
  //       replace
  //     />
  //   );
  // }

  return children;
});
